import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvironmentService } from '@experian-shared/services'; // NOSONAR
import { SessionManager } from '@experian/authentication'; // NOSONAR
@Injectable()
export class AuthService {

  constructor(
    public jwtHelper: JwtHelperService,
    private readonly http: HttpClient,
    public environmentService: EnvironmentService,
    private readonly sesisonManager: SessionManager
  ) {}

  public isAuthenticated(token): boolean {
    return !this.jwtHelper.isTokenExpired(token);
  }

  public get accessToken(): string {
    let accessToken = this.sesisonManager.accessToken || null;
    return accessToken = (accessToken !== null && accessToken !== undefined && accessToken !== '') ? accessToken :  localStorage.getItem('app-identity-token');
  }

  public get isLoggedIn(): boolean {
    return !!this.accessToken;
  }

}
